import type { UserSummary } from "./models";

export const emptyUser: UserSummary = {
  id: "",
  username: "",
  phone: "",
  avatar: "",
  balance: 0,
  score: 0,
  teamBalance: 0,
  level: 0,
  nextLevelBalance: 0,
  levelProgress: 0,
  fundBalance: 0,
  skpBalance: 0,
};

export function normalizeUser(
  raw: Record<string, unknown>,
  fallback: UserSummary = emptyUser,
): UserSummary {
  const levelTarget = Number(raw.levelBalance ?? 0);
  const levelRemaining = Number(
    raw.nextLevelBalance ?? fallback.nextLevelBalance,
  );
  const progress =
    levelTarget > 0
      ? Math.min(
          100,
          Math.max(0, ((levelTarget - levelRemaining) / levelTarget) * 100),
        )
      : Number(raw.levelProgress ?? fallback.levelProgress);

  return {
    id: String(raw.id ?? fallback.id),
    username: String(raw.username || fallback.username),
    phone: String(raw.phone || fallback.phone || ""),
    avatar: String(
      raw.head_img_full || raw.head_img || raw.avatar || fallback.avatar || "",
    ),
    balance: Number(raw.balance ?? fallback.balance),
    score: Number(raw.score ?? fallback.score),
    teamBalance: Number(
      raw.team_balance ?? raw.teamBalance ?? fallback.teamBalance,
    ),
    level: Number(raw.level ?? fallback.level),
    nextLevelBalance: Number(
      raw.nextLevelBalance ?? raw.levelBalance ?? fallback.nextLevelBalance,
    ),
    levelProgress: progress,
    fundBalance: Number(
      raw.fund_balance ?? raw.fundBalance ?? fallback.fundBalance,
    ),
    skpBalance: Number(
      raw.skp_balance ?? raw.skpBalance ?? fallback.skpBalance,
    ),
  };
}
